import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EnvironmentTiers } from 'environments/environment.models';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.tier === EnvironmentTiers.PRODUCTION) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
